/* @flow */
import moment from 'moment';

import ParamsLink from 'components/Links/ParamsLink';

import Td from 'components/UIKit/Table/Td';
import TrLink from '../TrLink';

export default function DynamicEntityRow({
  children, router, IconComponent,
}: any): React.Element {
  const newQuery = { did: children.id };
  const isActiveItem = children.id
    && (router.location.query.did === children.id);

  return (
    <TrLink
      isActiveItem={isActiveItem}
      linkId={children.id}
      router={router}
      >
      <Td>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <IconComponent style={{ marginRight: '.5rem' }} />
          {isActiveItem ? children.submitter_id : (
            <ParamsLink query={newQuery}>
              { children.submitter_id }
            </ParamsLink>
          )}
        </div>
      </Td>
      <Td style={{ textTransform: 'capitalize' }}>{ children.type }</Td>
      <Td style={{ textTransform: 'capitalize' }}>{ (children._related_cases || []).map(x => x.submitter_id).join(', ') }</Td>
      <Td style={{ textTransform: 'capitalize' }}>{ children.state }</Td>
      <Td>{ moment(new Date(children.updated_datetime)).format('ll') }</Td>
    </TrLink>
  );
}
